<template>
  <main class="main" role="main" style="overflow-x: hidden !important;">
    <div class="main__inner" v-if="certList.length <= 0"><!-- 배경: bg-->
      <div class="main__con">
        <div class="line"></div>
        <div class="main__con__ttl" v-if="isLoad">
          <div class="box__con__route_name type_02"> <!--세로정렬-->
            <span class="academy">인증 진행 현황</span>
            <span class="route">{{ userData.companyName }}</span>
          </div>
          <div class="small_notice">
            <div class="txt" style="margin: 0 auto;">
              <p><span style="font-size: 1.4rem;">현재 인증 정보를 등록 중입니다.</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main__inner" v-else><!-- 배경: bg-->
      <div class="main__con">
        <div class="line"></div>
        <div class="main__con__ttl" v-if="isLoad">
          <div class="box__con__route_name type_02"> <!--세로정렬-->
            <span class="academy">인증 진행 현황</span>
            <span class="route">{{ userData.companyName }}</span>
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status status__number on">진행 내용</span>
            </div>
          </div>
          <div class="box__con__flex_box" v-for="(cert, index) in certList" :key="index">
            <div class="box__con__status" v-if="!$Util.isEmpty(cert.progress)" @click="changeProgressInfoList(cert.progressInfoList)">
              <span class="status__work">{{ index + 1 }}</span>
              <div class="line"></div>
              <div class="progress-wrap">
                <span class="status status__number">{{ cert.progress }}</span>
                <span class="status status__doing"
                      :class="{off: cert.isComplete === -1, on: cert.isComplete === 1}">
                  {{ cert.isComplete === -1 ? '진행중' : '완료' }}
                </span>
                <span v-if="cert.isComplete === -1"
                      class="status status__number">{{ findProgressStatus(cert.progressInfoList) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="small_notice">
          <div class="txt" style="margin: 0 auto;">
            <p><span style="font-size: 1.4rem;">세부 진행 현황</span></p>
          </div>
          <!--          <button class="btn">진행중</button>-->
        </div>
        <div class="bus_route" id="statusWrap">
          <div class="progress" v-for="(item, index) in progressInfoList" :key="index">
            <div class="status">
              <div class="status__marker" :class="{'on' : item.isCurrentProgress === 1}"
                   :id="item.isCurrentProgress === 1 ? 'status_current' : ''"></div>
            </div>
            <div class="route">{{ item.progressStatus }}</div>
          </div>
        </div>
        <div class="small_notice">
          <div class="txt" style="margin: 0 auto;">
            <p><span style="font-size: 1.4rem;">인증 문의</span></p>
          </div>
        </div>
        <div class="cert_inquire_wrap">
          <div class="reply_wrap">
            <div v-show="!isWrite" @click="clickReplyWrap">문의를 남겨보세요.</div>
            <div v-show="isWrite">
              <textarea placeholder="내용을 입력하세요." rows="4" ref="replyTextArea"></textarea>
              <div class="button_wrap">
                <div class="btn_cancel" @click="cancelReply">취소</div>
                <div class="btn_submit" @click="submitReply">등록</div>
              </div>
            </div>
          </div>
          <ul class="cert_inquire_ul">
            <li class="cert_inquire_li" v-for="(row, index) in certInquireList" :key="index">
              <div class="write_wrap">
                <div class="write_name" v-if="row.type === 1">{{ userData.companyName }}</div>
                <div class="admin_name" v-else>{{ row.adminName }}</div>
                <div class="write_date">{{ $moment(row.regDate).format('YYYY.MM.DD HH:mm') }}</div>
              </div>
              <div class="inquire_content" v-html="$Util.nl2br(row.content)"></div>
              <div class="admin_reply" v-for="(reply, replyIndex) in row.certReplyList" :key="replyIndex">
                <div class="write_wrap">
                  <div class="admin_name">{{ row.adminName }}</div>
                  <div class="write_date">{{ $moment(reply.regDate).format('YYYY.MM.DD HH:mm') }}</div>
                </div>
                <div class="inquire_content" v-html="$Util.nl2br(reply.content)"></div>
              </div>
              <div class="divider"></div>
            </li>
          </ul>
        </div>
      </div>
      <!--      <div class="small_notice inquire">-->
      <!--        <p class="complete__txt__small" style="margin-top: 0; margin: 0 auto;">-->
      <!--          문의사항은 문의하기를 이용해주세요.-->
      <!--        </p>-->
      <!--      </div>-->
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      isLoad: true,
      certList: [],
      certInquireList: [],
      progressInfoList: [],
      isWrite: false,
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo
      }
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  created: function () {
    this.getCertInfo()
  },
  methods: {
    getCertInfo: async function () {
      const res = await this.$CertSvc.getCertInfo(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        this.certList = entity.certList
        this.certInquireList = entity.certInquireList

        for (let i = 0; i < this.certList.length; i++) {
          if (this.findProgressStatus(this.certList[i].progressInfoList) !== '') {
            this.progressInfoList = this.certList[i].progressInfoList
            break
          }
        }

        this.$nextTick(() => {
          this.$Util.scrollToStatus('status_current')
        })
      }
    },
    findProgressStatus: function (progressInfoList) {
      let find = progressInfoList.find(progress => progress.isCurrentProgress === 1);
      return find === undefined ? '' : find.progressStatus
    },
    changeProgressInfoList: function (progressInfoList) {
      this.progressInfoList = progressInfoList
      this.$nextTick(() => {
        this.$Util.scrollToStatus('status_current')
      })
    },
    clickReplyWrap: function () {
      this.isWrite = !this.isWrite
      setTimeout(() => {
        this.$refs.replyTextArea.focus()
      }, 1)
    },
    cancelReply: function () {
      this.isWrite = false
      this.$refs.replyTextArea.value = ''
    },
    submitReply: async function () {
      if (this.$refs.replyTextArea.value.length <= 0) {
        return false
      }

      const params = {
        type: 1,
        content: this.$refs.replyTextArea.value,
        userNo: this.userData.userNo
      }

      const res = await this.$CertSvc.registInquire(params)
      const code = res.code
      const message = res.message
      const entity = res.entity
      if (code === 1) {
        this.$Util.modalAlert({message: '문의가 접수 됐습니다.'})
        this.$refs.replyTextArea.value = ''
        this.isWrite = false
        await this.getCertInfo()
      } else {
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main__con {
  position: relative;

  .box__con__route_name.type_02 {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .box__con__status {
    margin-top: 0.5rem;

    .status__work {
      border: 1px solid #9E9E9E;
      margin-right: 0.8rem;
      color: #9E9E9E;
      font-weight: 500;
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 1.2rem;
      text-align: center;
      line-height: 2.2rem;
      font-size: 1.2rem;
    }

    .status__number {
      font-size: 1.4rem;
    }

    .status__number.on {
      color: black;
      padding-left: 0;
    }
  }

  .btn_call {
    padding: 0.3rem 0.8rem;
    border: 1px solid red;
    border-radius: 5rem;
    width: auto;
    background: #FFFFFF;
    font-size: 1.2rem;
    font-weight: 500;
    color: red;
  }

  .bus_route {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    padding: 5rem 10rem;

    .progress {
      display: inline-block;
      min-width: 17rem;

      &:not(:first-child):not(:last-child) {
        border-top: 1px #BDBDBD solid;
      }

      .status {
        position: relative;
        height: 1px;
      }

      &:first-child .status:after {
        content: "";
        display: block;
        width: 8.5rem;
        border-top: 1px #BDBDBD solid;
        margin-left: 8.5rem;
      }

      &:last-child .status:after {
        content: "";
        display: block;
        width: 8.5rem;
        border-top: 1px #BDBDBD solid;
      }

      .status__marker {
        position: absolute;
        top: -1.5rem;
        left: 7rem;
        padding: 1.5rem;
        background: url(../../assets/static/images/i_round.svg) no-repeat center;
      }

      .status__marker.on {
        background: url(../../assets/static/images/i_check.svg) no-repeat center;
      }

      .route {
        padding: 2rem 2.2rem;
        text-align: center;
        font-size: 1.4rem;
      }
    }
  }

  .small_notice.inquire {
    position: absolute;
    width: 100%;
    bottom: 0;
  }

  .progress-wrap {
    width: calc(100vw - 24px - 2rem - 1rem);

    span {
      display: inline-block;
      width: calc(41% - 0.8rem);

      &:last-child {
        color: blue;
        text-align: center;
      }
    }

    .status__doing {
      width: 15%;
      text-align: center;

      &.on {
        border-color: blue;
        color: blue;
      }

      &.off {
        border-color: red;
        color: red;
      }
    }
  }
}

.bus_route {
  padding: 0 !important;
  padding-top: 5rem !important;
  padding-bottom: 4rem !important;

  .progress {

    .route {
      padding: 1rem !important;
    }
  }
}

.cert_inquire_wrap {
  padding: 1rem;

  .reply_wrap {
    font-size: 1.4rem;
    background-color: rgba(245, 246, 248, .8);
    padding: 1rem;
    border-radius: 1rem;
    margin-bottom: 1rem;

    textarea {
      border: none;
      background-color: rgba(245, 246, 248, .8);
      padding: 0.2rem;
    }

    .button_wrap {
      display: flex;
      justify-content: flex-end;
      border-top: #ebebeb solid 1px;
      padding-top: 0.6rem;
      gap: 1rem;

      .btn_cancel {
        color: #676767;
        background-color: #e5e7ea;
        padding: 0.4rem 1rem;
        border-radius: 0.6rem;
      }

      .btn_submit {
        color: #1980C3;
        background-color: rgba(25,128,195,.12);
        padding: 0.4rem 1rem;
        border-radius: 0.6rem;
      }
    }
  }

  .cert_inquire_ul {
    .cert_inquire_li {
      padding: 0.8rem;

      .divider {
        border-bottom: #ebebeb solid 1px;
        padding-top: 0.5rem;
      }

      &:not(:first-child) {
        padding-top: 0;
      }

      background-color: rgba(245, 246, 248, .8);
      .write_wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .write_name {
          font-size: 1.4rem;
          color: black;
          font-weight: bold;
          padding-left: 0.6rem;
          padding-right: 0.6rem;

          border: blue solid 1px;
          border-radius: 1rem;
          background-color: lightblue;
        }

        .admin_name {
          font-size: 1.4rem;
          color: black;
          font-weight: bold;
          padding-left: 0.6rem;
          padding-right: 0.6rem;

          border: green solid 1px;
          border-radius: 1rem;
          background-color: lightgreen;
        }

        .write_date {
          font-size: 1.2rem;
        }
      }

      .inquire_content {
        margin-top: 0.4rem;
        margin-bottom: 0.4rem;
        padding: 0 0.5rem;
        font-size: 1.4rem;
      }

      .admin_reply {
        padding-top: 0.8rem;
        padding-left: 2rem;
      }
    }
  }
}
</style>
